import Types from '../types'

const initialState = {
    costAndSecurity: null,
    vulnerabilityDetails: null
};

export default function analyticsReducer(state = initialState, action) {
    switch (action.type) {
        case Types.COST_AND_SECURITY:
            return {
                ...state,
                costAndSecurity: action.payload
            };
        case Types.VULNERABILITY_DETAILS:
            return {
                ...state,
                vulnerabilityDetails: action.payload
            };
        default:
            return state;
    }
}